import QuantitySelector from './QuantitySelector';

export default QuantitySelector;



// WEBPACK FOOTER //
// ./src/components/shared/QuantitySelector/index.js